import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ChannelProvider = ({ pluginKey }) => {
  const location = useLocation();

  const loadScript = () => {
    return new Promise((resolve, reject) => {
      if (window.ChannelIO) {
        console.log("ChannelIO script already loaded.");
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
      script.async = true;
      script.onload = async () => {
        // ChannelIO가 정의될 때까지 대기
        let retries = 10; // 최대 10회 재시도
        while (!window.ChannelIO && retries > 0) {
          console.log("Waiting for ChannelIO to be ready...");
          await new Promise((resolve) => setTimeout(resolve, 300)); // 300ms 대기
          retries--;
        }

        if (window.ChannelIO) {
          resolve();
        } else {
          reject(
            new Error("ChannelIO script failed to initialize after retries")
          );
        }
      };
      script.onerror = () =>
        reject(new Error("Failed to load ChannelIO script"));
      document.body.appendChild(script);
    });
  };

  const initializeChannelTalk = async () => {
    try {
      await loadScript();
      // ChannelIO가 정의될 때까지 대기
      let retries = 10; // 최대 10회 재시도
      while (!window.ChannelIO && retries > 0) {
        console.log("Waiting for ChannelIO to be ready...");
        await new Promise((resolve) => setTimeout(resolve, 300)); // 300ms 대기
        retries--;
      }
      console.log(window.ChannelIO);
      if (window.ChannelIO) {
        window.ChannelIO("boot", { pluginKey });
        window.ChannelIOInitialized = true;
        console.log("ChannelIO initialized successfully.");
      } else {
        throw new Error("ChannelIO not available after script load");
      }
    } catch (error) {
      console.error("Failed to initialize ChannelTalk:", error);
    }
  };

  useEffect(() => {
    initializeChannelTalk();

    return () => {
      if (window.ChannelIO) {
        window.ChannelIO("shutdown");
        console.log("ChannelIO shut down successfully.");
      }
    };
  }, [location.pathname, pluginKey]);

  return null;
};

export default ChannelProvider;
